import { DELETE_OR_UPDATE_CENTER, GET_APPS, GET_CENTERS, GET_PACKAGES, POST_CENTER } from "resources/ApiUrls";
import MyAxiosInstance from "utils/MyAxiosInstance";

const getCenters = () => MyAxiosInstance.get(GET_CENTERS);

const getApps = () => MyAxiosInstance.get(GET_APPS);

const getPackages = () => MyAxiosInstance.get(GET_PACKAGES);

const create = (centerObj) => MyAxiosInstance.post(POST_CENTER, centerObj)

const remove = (centerId) => MyAxiosInstance.delete(DELETE_OR_UPDATE_CENTER(centerId))

const update = (centerId, fieldsToUpdate) => MyAxiosInstance.patch(DELETE_OR_UPDATE_CENTER(centerId), fieldsToUpdate)

const centerConsts = { getCenters, getApps, getPackages, create, update, remove };

export default centerConsts;